import { computed, effect, Injectable, signal, inject } from '@angular/core';
import { TypePaymentMethod } from '../models';
import { vatRegex } from '../../../../shared/validators/custom-validators';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { CurrentUserState } from '../../../../core/store/current-user/current-user.state';

@Injectable({
  providedIn: 'root',
})
export class PaymentDataService {
  private readonly store = inject(Store);

  selectedMethod = signal<TypePaymentMethod>('online');
  selectedOnlinePaymentType = signal<string>('card');
  selectedCountry = signal<string>('');

  taxId: FormControl<string | null> = new FormControl<string>('', {
    validators: [],
  });
  companyName: FormControl<string | null> = new FormControl<string>('', {
    validators: Validators.required,
  });

  readonly isTaxIdRequired = computed(() => this.selectedCountry() !== 'DE');
  readonly taxIdName = computed(() => {
    switch (this.selectedCountry()) {
      case 'US':
        return 'payment.taxId.us';
      case 'GI':
        return 'payment.taxId.gi';
      default:
        return 'payment.taxId.default';
    }
  });

  constructor() {
    effect(() => {
      this.taxId.clearValidators();
      const pattern = vatRegex(this.selectedCountry());
      const validators = [Validators.pattern(pattern)];
      if (this.isTaxIdRequired()) {
        validators.push(Validators.required);
      }
      this.taxId.setValidators(validators);
      this.taxId.updateValueAndValidity();
    });
  }

  setCompanyName() {
    const companyName = this.store.selectSnapshot(
      CurrentUserState.organizationName,
    );
    if (companyName) {
      this.companyName.setValue(companyName);
    }
  }
}
